import { ForwardIcon } from "@/components/icons/forward-icon";
import { cn } from "@/utils/cn";
import { triggerHaptic } from "@/utils/haptics";
import { safeAreaBottomInset } from "@/utils/safe-area-classes";

interface OnboardingNextFabProps {
  onClick: () => void;
  disabled?: boolean;
  visible?: boolean;
}

export const OnboardingNextFab = ({
  onClick,
  disabled = false,
  visible = true,
}: OnboardingNextFabProps) => {
  if (!visible) return null;

  const handleClick = () => {
    triggerHaptic();
    onClick();
  };

  return (
    <div className={cn("fixed right-4 isolate z-50", safeAreaBottomInset("1.5rem"))}>
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        aria-label="Next"
        className="flex size-14 items-center justify-center overflow-hidden rounded-full bg-[linear-gradient(to_bottom,#513775,#43246e)] pl-1 shadow-md active:bg-[linear-gradient(#281642,#281642)] disabled:cursor-not-allowed"
      >
        <ForwardIcon className="stroke-white" />
      </button>
    </div>
  );
};
